import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { receiveProductsWrapper } from '../Actions/LoadMore.action';
import LoadMoreButton from '../Components/LoadMore/LoadMoreButton';
import ProgressBar from '../Components/ProgressBar/ProgressBar';
import { translate } from '../Services/translation';

export default (props) => {
  const { productsWrapper } = useSelector((state) => state.productsView);
  const { products, pagination } = productsWrapper;
  const pageSize = pagination.pageSize;
  const totalProducts = pagination.totalCount;

  const dispatch = useDispatch();

  const onLoaded = (res) => {
    dispatch(
      receiveProductsWrapper({
        ...res.result.productsWrapper,
        products: [...products, ...res.result.productsWrapper.products],
      })
    );
  };

  useEffect(() => {
    const url = new URL(location.href);
    url.searchParams.set('products', products?.length ?? pageSize);
    window.history.replaceState(null, document.title, url);
  }, [products, pageSize]);

  var notAllLoaded =
    totalProducts != products.length && totalProducts > pageSize;

  return (
    <>
      {notAllLoaded && (
        <LoadMoreButton
          {...props}
          skip={products.length}
          take={pageSize}
          onLoaded={onLoaded}
        />
      )}
      <ProgressBar progress={products.length} max={totalProducts} />
      <div className="load-more-products__count-text">
        <span id="shown-products-counter">
          {products.length < totalProducts ? products.length : totalProducts}
        </span>{' '}
        {translate('global.of').toLowerCase()} {totalProducts}{' '}
        {translate('global.products').toLowerCase()}
      </div>
    </>
  );
};
